import SuperAdminDashboard from "../superadmin/Dashboard";
import CustomerManagementPage from "../superadmin/CustomerManagementPage";
import CustomerAccessControlPage from "../superadmin/CustomerAccessControlPage";
import CustomerPrinterSetupPage from "../superadmin/CustomerPrinterSetupPage";
import AddonRequestsPage from "../superadmin/AddonRequestsPage";
import MailConfigPage from "../superadmin/MailConfigPage";
import PaymentSettingsPage from "../superadmin/PaymentSettingsPage";
import MasterDataPage from "../superadmin/MasterDataPage";
import SubscriptionSettingsPage from "../superadmin/SubscriptionSettingsPage";
import UnderConstructionPage from "../components/CommonComponents/UnderConstructionIcon";
import ProtectedRoute from "./ProtectedRoute";
import { ThemeProvider } from "../components/CommonComponents/ThemeProvider";

export const superadminRoutes = [
    {
        path: "/superadmin/dashboard",
        element: <ProtectedRoute allowedRoles={[0]}><SuperAdminDashboard /></ProtectedRoute>,
    },
    {
        path: "/superadmin/customers",
        element: <ProtectedRoute allowedRoles={[0]}><CustomerManagementPage /></ProtectedRoute>,
    },
    {
        path: "/superadmin/add-on-requests",
        element: <ProtectedRoute allowedRoles={[0]}><AddonRequestsPage /></ProtectedRoute>,
    },
    {
        path: "/superadmin/mail-config",
        element: <ProtectedRoute allowedRoles={[0]}><MailConfigPage /></ProtectedRoute>,
    },
    {
        path: "/superadmin/payment-settings",
        element: <ProtectedRoute allowedRoles={[0]}><PaymentSettingsPage /></ProtectedRoute>,
    },
    {
        path: "/superadmin/customer-printer-setup",
        element: <ProtectedRoute allowedRoles={[0]}><CustomerPrinterSetupPage /></ProtectedRoute>,
    },
    {
        path: "/superadmin/subscription-settings",
        element: <ProtectedRoute allowedRoles={[0]}><SubscriptionSettingsPage /></ProtectedRoute>,
    },
    {
        path: "/superadmin/master-data",
        element: <ProtectedRoute allowedRoles={[0]}><MasterDataPage /></ProtectedRoute>,
    },
    {
        path: "/superadmin/customer-access-control",
        element: <ProtectedRoute allowedRoles={[0]}><CustomerAccessControlPage /></ProtectedRoute>,
    },
    {
        path: "/superadmin/settings",
        element: <ProtectedRoute allowedRoles={[0]}><UnderConstructionPage /></ProtectedRoute>,
    },
    {
        path: "/superadmin/appearance",
        element: <ProtectedRoute allowedRoles={[0]}><ThemeProvider /></ProtectedRoute>,
    },
];
